<form [formGroup]="form" class="flex column start center w-100 g-16" (ngSubmit)="save()">
	<h4>{{ 'account.account' | translateWithKeys }}</h4>
	<div class="flex column start center w-100">
		<div class="flex column start center w-100">
			<span class="title">{{ 'general.email' | translateWithKeys }}</span>
			<mat-form-field appearance="outline" class="w-100">
				<input matInput type="text" disabled [value]="user?.email">
			</mat-form-field>
		</div>
	</div>
	<div class="flex row start center w-100 names-container">
		<div class="w-50">
			<p class="title">{{ 'account.first_name' | translateWithKeys }}</p>
			<mat-form-field appearance="outline" class="w-100">
				<input matInput type="text" formControlName="name" name="name" [placeholder]="'account.first_name' | translateWithKeys">
				@if (form.controls?.['name']?.errors?.['required'] && form.controls?.['name']?.touched) {
					<mat-error>
						{{ 'account.first_name_required' | translateWithKeys }}
					</mat-error>
				}
			</mat-form-field>
		</div>
		<div class="w-50">
			<p class="title">{{ 'account.last_name' | translateWithKeys }}</p>
			<mat-form-field appearance="outline" class="w-100">
				<input matInput type="text" formControlName="lastName" name="lastName" [placeholder]="'account.last_name' | translateWithKeys">
				@if (form.controls?.['lastName']?.errors?.['required'] && form.controls?.['lastName']?.touched) {
					<mat-error>
						{{ 'account.last_name_required' | translateWithKeys }}
					</mat-error>
				}
			</mat-form-field>
		</div>
	</div>
	<button mat-flat-button class="bg-primary-darker button text-accent-lighter" [disabled]="form.invalid || !hasNameOrLastNameChanged" type="submit">
		Save
	</button>
</form>
